<template>
    <div>
        <div class="row mb-5">
            <div class="col-md">
                <h5 class="text-muted font-weight-normal">
                    HERRAMIENTA Nº {{number}}
                </h5>
                <h3>
                    {{tool.title}}
                </h3>
                <span v-html="tool.queEs"></span>
            </div>
            <div class="col-md">
                <div class="video-wrapper">
                    <div class="icon d-none d-sm-block">
                        <img :src="require('../assets/images/' + tool.icon)" class="img-fluid">
                    </div>
                    <iframe :src="tool.video+'?modestbranding=1&autohide=1&controls=0'" frameborder="0" allowfullscreen class="video"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        tool: {},
        number: {},
    }
}
</script>
<style lang="scss" scoped>
    .video-wrapper{
        height: 300px;
        width: 100%;
        position: relative;
        .icon{
            top: -45px;
            right: -45px;
            z-index: 99;
            position: absolute;
            width: 90px;
            background: #5A57DF;
            height: 90px;
            border-radius: 50px;
            text-align: center;
            line-height: 90px;
        }
    }
    .video{
        width: 100%;
        height: 100%;
        border-radius: 10px;
        border: 0;
    }
</style>